<template>
  <div>
    <div id="cal1" />
    <div id="cal2" />
    <div
      class="quick-links"
      v-show="quickLinkStore.showQuickLink"
      :style="{ left: x + 'px', top: y + 'px' }"
    >
      <BaseLink
        v-for="qso in quickLinkOptions.filter((qso) => qso?.toLink)"
        :key="qso.label.ja"
        :to="qso.toLink(quickSearchKeyword)"
        :searchscroll="true"
        :stop="true"
        @click.native="hideQuickLink"
      >{{ ls(qso.label) }}</BaseLink
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()
const { ls } = useI18n()
const quickLinkStore = useQuickLinkStore()

const x: Ref<number> = ref(0)
const y: Ref<number> = ref(0)
const quickSearchKeyword: Ref<string> = ref('')

onMounted(() => {
  document.addEventListener('mouseup', (e) => {
    if (route.meta?.qsearch) {
      const selection = document.getSelection()
      const selectedText = selection?.toString().trim()

      const rel1 = document.createRange()
      rel1.selectNode(document.getElementById('cal1'))
      const rel2 = document.createRange()
      rel2.selectNode(document.getElementById('cal2'))

      if (selectedText && !selection.isCollapsed) {
        const r = selection.getRangeAt(0).getBoundingClientRect()
        const rb1 = rel1.getBoundingClientRect()
        const rb2 = rel2.getBoundingClientRect()

        x.value = ((r.left - rb2.left) * 100) / (rb1.left - rb2.left)
        y.value = ((r.bottom - rb2.top) * 100) / (rb1.top - rb2.top) + 8

        quickSearchKeyword.value = selectedText
        quickLinkStore.showQuickLink = true
      } else {
        quickLinkStore.showQuickLink = false
      }
    }
  });
})

const quickLinkOptions = computed<QuickLinkOption[]>(() => {
  let options = []
  if (quickSearchKeyword.value != '') {
    options.push({
      label: dapLangGlobal.quickSearchLink,
      toLink: (keyword) => {
        return searchTo({ csid: systemCrossSearchId(), keyword: [keyword] })
      }
    })
  }
  if (quickLinkStore.quickLinkOptions) {
    options.push(...quickLinkStore.quickLinkOptions)
  }
  return options
})

const hideQuickLink = () => {
  quickLinkStore.showQuickLink = false
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.quick-links {
  box-shadow: $component-shadow;
  border: 0.5px solid $jps-gray-300;
  font-size: $size-7;
  position: absolute;
  background: $white;
  border-radius: 2px;
  padding: 2px;
  z-index: 9999;
  display: grid;
  a {
    display: block;
  }
}
#cal1 {
  position: absolute;
  height: 0px;
  width: 0px;
  top: 100px;
  left: 100px;
  overflow: none;
  z-index: -100;
}
#cal2 {
  position: absolute;
  height: 0px;
  width: 0px;
  top: 0px;
  left: 0px;
  overflow: none;
  z-index: -100;
}
</style>
